import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  collapse: {
    backgroundColor: "#FCFCFD",
    width: '100%',
    padding: "0 16px"
  },
  containerOptions: {
    display: "flex",
    flexDirection: "row",
    padding: "10px 0"
  },
  checkbox: {
    padding: 0,
    marginRight: "15px"
  },
  textOption: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "24px",
    display: "flex",
    alignItems: "center",
    color: "#465869"
  }
}))

export default styles;